type CallKind = 'call' | 'identify' | 'reset'

interface QueuedCall {
  kind: CallKind
  run: () => void
}

export function createCallQueue(limit = 100) {
  let calls: QueuedCall[] = []
  return {
    push: (kind: CallKind, run: () => void): void => {
      calls.push({ kind, run })
      if (calls.length > limit) {
        const index = calls.findIndex(
          (call, position) =>
            call.kind === 'call' ||
            calls.slice(position + 1).some((later) => later.kind === call.kind),
        )
        calls.splice(Math.max(index, 0), 1)
      }
    },
    drain: (): void => {
      const pending = calls
      calls = []
      for (const call of pending) {
        call.run()
      }
    },
  }
}
